import axios from "axios";

const REACT_APP_API = process.env.REACT_APP_API_BASE_URL;

export const ApprovalRequest = async (params) => {
  try {
    const response = await axios.post(
      `${REACT_APP_API}/api/Organization/Approval/CreateApprovalRequest`,
      params,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error in Create Approval Request:", error);
    throw error;
  }
};

export const GetApprovalRequest = async (requestBody) => {
  console.log(
    "Approval url",
    `${REACT_APP_API}/api/Organization/Approval/GetRequestedApprovals`,
  );
  try {
    const response = await axios.post(
      `${REACT_APP_API}/api/Organization/Approval/GetRequestedApprovals`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching Requested Approvals:", error);
    throw error;
  }
};

// export const GetApprovalDetails = async (referenceNo) => {
//   try {
//     const response = await axios.get(
//       `${REACT_APP_API}/api/Organization/Approval/ApprovalDetails`,
//       {
//         params: {
//           ReferenceNo: referenceNo,
//         },
//         headers: {
//           "Content-Type": "application/json",
//         },
//       }
//     );
//     console.log(response.data);
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching agency details:", error);
//     throw error.response?.data || error;
//   }
// };
export const GetApprovalDetails = async (referenceNo, productType) => {
  try {
    const response = await axios.get(
      `${REACT_APP_API}/api/Organization/Approval/ApprovalDetails`,
      {
        params: {
          ReferenceNo: referenceNo,
          productType: productType,
        },
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching agency details:", error);
    throw error.response?.data || error;
  }
};

export const AcceptApprovalRequest = async (requestBody) => {
  //console.log("Approval url",`${REACT_APP_API}/api/Organization/Approval/GetRequestedApprovals`);
  try {
    const response = await axios.post(
      `${REACT_APP_API}/api/Organization/Approval/AcceptApprovalRequest`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching Requested Approvals:", error);
    throw error;
  }
};

export const RejectApprovalRequest = async (requestBody) => {
  try {
    const response = await axios.post(
      `${REACT_APP_API}/api/Organization/Approval/RejectApprovalRequest`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching Requested Approvals:", error);
    throw error;
  }
};
